import { render, staticRenderFns } from "./loading.md?vue&type=template&id=96d47e12&"
var script = {}
import style0 from "./loading.md?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports